// import React from "react";

// /**
//  * Renders the AI "student_issues_summary" returned by the webinar_insights API.
//  * Generic on purpose: works whether the backend dict is
//  *   { "Topic A": "text", ... }
//  *   { "Topic A": { "summary": "...", "key_issues": ["..."] }, ... }
//  *   or { "summary": "text" }
//  * Text is rendered as plain text (React escapes it), not as HTML.
//  */

// const formatTitle = (str) =>
//   String(str).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

// const isEmpty = (v) =>
//   v === null ||
//   v === undefined ||
//   v === "" ||
//   (Array.isArray(v) && v.length === 0) ||
//   (typeof v === "object" && !Array.isArray(v) && Object.keys(v).length === 0);

// const renderValue = (value, depth = 0) => {
//   if (isEmpty(value)) return null;

//   if (Array.isArray(value)) {
//     return (
//       <ul className="ps-3 mb-2">
//         {value.map((item, i) => (
//           <li key={i} className="mb-1">
//             {typeof item === "object" ? renderValue(item, depth + 1) : String(item)}
//           </li>
//         ))}
//       </ul>
//     );
//   }

//   if (typeof value === "object") {
//     return Object.entries(value).map(([key, val]) => {
//       if (isEmpty(val)) return null;

//       // top level keys (topics) are section headings
//       if (depth === 0) {
//         return (
//           <div key={key} className="mb-3">
//             <h6 className="fw-bold mb-1">{formatTitle(key)}</h6>
//             {renderValue(val, depth + 1)}
//           </div>
//         );
//       }

//       const primitive = typeof val !== "object";
//       return (
//         <div key={key} className="mb-1">
//           <strong>
//             {formatTitle(key)}
//             {primitive ? ": " : ""}
//           </strong>
//           {primitive ? String(val) : renderValue(val, depth + 1)}
//         </div>
//       );
//     });
//   }

//   return <p className="mb-2">{String(value)}</p>;
// };

// const StudentIssuesSummary = ({ summary, title = "" }) => {
//   if (isEmpty(summary)) return null;

//   return (
//     <div className="mb-3 p-3 border rounded shadow-sm">
//       <h5 className="fw-bold mb-2">{title}</h5>
//       {renderValue(summary)}
//     </div>
//   );
// };

// export default StudentIssuesSummary;




import React from "react";

const formatTitle = (str) =>
  String(str).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const isEmpty = (v) =>
  v === null ||
  v === undefined ||
  v === "" ||
  (Array.isArray(v) && v.length === 0) ||
  (typeof v === "object" && !Array.isArray(v) && Object.keys(v).length === 0);

const StudentIssuesSummary = ({ summary }) => {
  if (isEmpty(summary)) return null;

  const categoryKeys = Object.keys(summary).filter((k) => !isEmpty(summary[k]));
  if (categoryKeys.length === 0) return null;

  return (
    <>
      {categoryKeys.map((categoryKey) => {
        const category = summary[categoryKey] || {};
        const { summary: categorySummary, topics } = category;
        const topicKeys = topics ? Object.keys(topics).filter((t) => !isEmpty(topics[t])) : [];

        return (
          <div key={categoryKey} className="mb-4">
            <h5 className="fw-bold mb-1">{formatTitle(categoryKey)}</h5>

            {!isEmpty(categorySummary) && (
              <>
                <div className="text-uppercase text-muted small fw-semibold mb-1">
                  Summary
                </div>
                <p className="mb-3">{categorySummary}</p>
              </>
            )}

            {topicKeys.map((topicName) => (
              <div
                key={topicName}
                className="mb-2 p-3 border rounded shadow-sm bg-light"
              >
                <h6 className="fw-bold mb-2">{topicName}</h6>
                <ul className="ps-3 mb-0">
                  {topics[topicName].map((issue, idx) => (
                    <li key={idx} className="mb-1">
                      {issue}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        );
      })}
    </>
  );
};

export default StudentIssuesSummary;